import React, { createContext, useMemo, useState } from 'react';

const SearchModalContext = createContext();

const SearchModalContextProvider = ({ children }) => {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const initialValue = useMemo(
    () => ({
      isSearchModalOpen,
      searchQuery,
      setSearchQuery,
      openSearchModal: () => {
        setIsSearchModalOpen(true);
      },
      openSearchModalWithQuery: (query) => {
        setSearchQuery(query || '');
        setIsSearchModalOpen(true);
      },
      closeSearchModal: () => {
        setIsSearchModalOpen(false);
      },
    }),
    [isSearchModalOpen, searchQuery]
  );

  return (
    <SearchModalContext.Provider value={initialValue}>
      {children}
    </SearchModalContext.Provider>
  );
};

export { SearchModalContext, SearchModalContextProvider };
